import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import {
  HashLocationStrategy,
  LocationStrategy,
  CommonModule,
} from "@angular/common";
import { StoreModule } from "@ngrx/store";
import { en_US, NgZorroAntdModule, NZ_I18N } from "ng-zorro-antd";

import { AppComponent } from "./app.component";
import { ROUTES, RoutingModule } from "./routing/routing.module";
import { LayoutModule } from "./layout/layout.module";
import { UIModule } from "./ui/ui.module";
import { PagesModule } from "./pages/pages.module";
import { pageDataReducer } from "./store/reducers/page-data.reducer";
import { appSettingsReducer } from "./store/reducers/app-settings.reducer";
import { patientsReducer } from "./store/reducers/patients.reducer";
import { LoginService } from "./layout/components/login-form/login-form.service";
import { MainService } from "./pages/main/main.service";
import { ForgotPssService } from "./layout/components/forgot-form/forgot-form.service";
import { ResetPssService } from "./layout/components/reset-form/reset-form.service";
//import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AuthGuard } from "./auth-guard/auth-guard";
//import { UsersService } from './pages/users/users.service';
import { FoodBudInterceptor } from "../app/interceptor/food_bud.interceptor";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NotifierModule } from "angular-notifier";
import { NgHttpLoaderModule } from "ng-http-loader"; // <============
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import {
  SocialLoginModule,
  SocialAuthServiceConfig,
} from "angularx-social-login";
import {
  GoogleLoginProvider,
  FacebookLoginProvider,
} from "angularx-social-login";

import { GuestGuard } from "./auth-guard/guest-guard";
import {
  BottomSheetOverviewNote,
  BottomSheetCategory,
} from "./pages/guest/food-menu/food-menu.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AgmCoreModule } from "@agm/core";
import { environment } from "src/environments/environment";
import { AgmDirectionModule } from "agm-direction";
import { BottomSheetOverviewOtp } from "./pages/resto-page/resto-page.component";
import { NgOtpInputModule } from "ng-otp-input";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { BottomSheetDishAddon } from "./pages/guest/order-menu";
import { IvyCarouselModule } from "angular-responsive-carousel";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";

@NgModule({
  declarations: [AppComponent, BottomSheetOverviewNote],
  imports: [
    NgOtpInputModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    HttpClientModule,
    RouterModule.forRoot(ROUTES),
    StoreModule.forRoot({
      pageData: pageDataReducer,
      appSettings: appSettingsReducer,
      patients: patientsReducer,
    }),
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapApiKey,
      libraries: ["places"],
    }),
    AgmDirectionModule,
    NgHttpLoaderModule.forRoot(),
    NgZorroAntdModule,
    NotifierModule,
    RoutingModule,
    LayoutModule,
    UIModule,
    PagesModule,
    BrowserAnimationsModule,
    SocialLoginModule,
    NgbModule,
    IvyCarouselModule,
    GooglePlaceModule,
  ],
  providers: [
    {
      provide: "SocialAuthServiceConfig",
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              "604640065720-cf5vuvhog40ufnhuugvesdsv9klu96o5"
            ),
          },                                                                                                                                                                                                  
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            // provider: new FacebookLoginProvider("816256809534449"),
            provider: new FacebookLoginProvider("2026481171074167"),

          },
        ],
      } as SocialAuthServiceConfig,
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },                                                      
    { provide: NZ_I18N, useValue: en_US },
    {                     
      provide: HTTP_INTERCEPTORS,
      useClass: FoodBudInterceptor,
      multi: true,
    },
    AuthGuard,
    GuestGuard,
    LoginService,
    ForgotPssService,
    ResetPssService,
    MainService,
  ],
  entryComponents: [
    BottomSheetOverviewNote,
    BottomSheetOverviewOtp,
    BottomSheetCategory,
    BottomSheetDishAddon,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }

declare module "@angular/core" {
  interface ModuleWithProviders<T = any> {
    ngModule: Type<T>;
    providers?: Provider[];
  }
}
